import { render } from "./ProductMovementsRapport.vue?vue&type=template&id=4dce8826&scoped=true&ts=true"
import script from "./ProductMovementsRapport.vue?vue&type=script&lang=ts"
export * from "./ProductMovementsRapport.vue?vue&type=script&lang=ts"

import "./ProductMovementsRapport.vue?vue&type=style&index=0&id=4dce8826&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dce8826"]])

export default __exports__